/** 租户维度缓存微信 OpenID（登录绑定或小程序写入后复用到入会申请）。 */

function storageKey(tenantLegacyId: string) {
  return `football_tenant_wx_openid:${tenantLegacyId}`;
}

export function getStoredWxOpenIdForTenant(tenantLegacyId: string): string | undefined {
  try {
    const v = localStorage.getItem(storageKey(tenantLegacyId))?.trim();
    return v || undefined;
  } catch {
    return undefined;
  }
}

export function setStoredWxOpenIdForTenant(tenantLegacyId: string, wxOpenId: string): void {
  try {
    localStorage.setItem(storageKey(tenantLegacyId), wxOpenId.trim());
  } catch {
    /* ignore quota */
  }
}
